<template>
  <div class="vue3-parent">
    <h1>Подготовка к миграции на Vue 3</h1>
    
    <Vue3Syntax>
      <template v-slot:header>
        <h1 class="card-title">Использование slot</h1>
      </template>
      <!-- <h1 slot="header" class="card-title">использование slot</h1> -->
      <template v-slot:problem>
        <p>Недопустимо указание тега <code>&lt;tagname slot="">&lt;/tagname></code></p>
      </template>
      <template v-slot:default>
        <ul>
          <ol>Все слоты надо помещать в <code>&lt;template #slotname>&lt;/template></code> или <code>&lt;template v-slot="slotname">&lt;/template></code></ol>
          <ol>Если сейчас слот указан в теге, например <code>&lt;h1 slot="header" class="card-title"></code>, то это надо переписать на <code>&lt;template #header>&lt;h1 class="card-title"></code></ol>
          <ol>Вот такое <code>&lt;i class="tim-icons icon-check-2" slot="on">&lt;/i></code>, надо переписать на <code>&lt;template #on>&lt;i class="tim-icons icon-check-2">&lt;/i>&lt;/template></code></ol>
        </ul>
      </template>
    </Vue3Syntax>

    <Vue3Syntax>
      <template v-slot:header>
        <h1 class="card-title">Использование slot-scope (v-slot)</h1>
      </template>
      <template v-slot:problem>
        <p>В Vue 2 использовался атрибут <code>slot-scope</code>, но в Vue 3 он устарел. Вместо него нужно использовать <code>v-slot</code>.</p>
        <b>Vue 2 (устаревший синтаксис):</b>
        <p><code>&lt;template slot-scope="scope">
  {{ '{{ scope.row.block_tree }' }}{{ '}' }}
  &lt;/template></code></p>
        <b>Vue 3 (современный синтаксис):</b>
        <p><code>&lt;template #default="{ row }">
  {{ '{{ row.block_tree }' }}{{ '}' }}
  &lt;/template></code></p>
      </template>
      <template v-slot:default>
        <ul>
          <ol>Передавайте параметры через destructuring: <code>{ row }</code> вместо <code>scope.row</code></ol>
          <ol><code>&lt;template slot-scope="scope">&lt;base-input v-model="scope.row.phone" autocomplete="off" type="text"/>&lt;/template></code> заменить на <code>&lt;template #default="row">&lt;base-input v-model="row.phone" autocomplete="off" type="text"/>&lt;/template></code></ol>
        </ul>
      </template>
    </Vue3Syntax>
  </div>
</template>

<script>
import Vue3Syntax from './Vue3Syntax.vue';

export default {
  name: 'Vue3Parent',
  components: {
    Vue3Syntax,
  },
  
  data() {
    return {
    };
  },
  
  methods: {
  }
};
</script>

<style scoped>
.vue3-parent {
  padding: 20px;
  font-family: Arial, sans-serif;
  background-color: #f7f9fa;
  border-radius: 20px;
}

h1 {
  color: #42b983;
  margin-bottom: 20px;
}
</style>
